import { FM_ACTION_ITEMS_TYPE } from '../../../constants';
import {
    ActionItemCombinedContent,
    ActionItemContent,
} from '../../../models/experiencefragments/action-item';
import { replacePlaceholderByValue } from '../../utils/placeholder-util/replace-placeholder-by-value';

export const transformToActionItemContent = (
    apiData: any,
    content: ActionItemCombinedContent,
    uomDistance: number
): ActionItemContent => {
    const getCardTitle = () => {
        if (apiData && apiData.oilLifeData && apiData.scheduleMaintenanceData) {
            return content.combinedTitle;
        } else if (
            apiData &&
            apiData.oilLifeData &&
            apiData.scheduleMaintenanceData === null
        ) {
            return content.oilLifeTitle;
        } else if (
            apiData &&
            apiData.scheduleMaintenanceData &&
            apiData.oilLifeData === null
        ) {
            return content.scheduledMaintenanceTitle;
        } else return '';
    };

    const getCurrentMileage = (): string => {
        if (uomDistance === 1) {
            return apiData?.scheduleMaintenanceData?.featureData
                ?.nextIntervalMiles !== undefined &&
                apiData?.scheduleMaintenanceData?.featureData
                    ?.remainingMiles !== undefined
                ? (
                      apiData.scheduleMaintenanceData.featureData
                          .nextIntervalMiles -
                      apiData.scheduleMaintenanceData.featureData.remainingMiles
                  ).toString()
                : '0';
        } else {
            if (uomDistance === 2) {
                return apiData?.scheduleMaintenanceData?.featureData
                    ?.nextIntervalKMs !== undefined &&
                    apiData?.scheduleMaintenanceData?.featureData
                        ?.remainingKMs !== undefined
                    ? (
                          apiData.scheduleMaintenanceData.featureData
                              .nextIntervalKMs -
                          apiData.scheduleMaintenanceData.featureData
                              .remainingKMs
                      ).toString()
                    : '0';
            }
        }
        return '0';
    };
    const currentMileage = getCurrentMileage();
    const getDistanceUnit = (
        uomDistance: number,
        distanceunitForMiles: string,
        distanceunitForKm: string
    ) => (uomDistance === 1 ? distanceunitForMiles : distanceunitForKm);

    const distanceUnit = getDistanceUnit(uomDistance, 'miles', 'km');
    const getCardSubTitle = () => {
        if (apiData && apiData.oilLifeData && apiData.scheduleMaintenanceData) {
            return replacePlaceholderByValue(content.combinedSubTitle, {
                oilLife: apiData.oilLifeData.featureData.iolm,
                currentMileage: currentMileage,
                mileageInterval:
                    uomDistance === 1
                        ? apiData.scheduleMaintenanceData.featureData
                              .nextIntervalMiles
                        : apiData.scheduleMaintenanceData.featureData
                              .nextIntervalKMs,
                distanceUnit: distanceUnit,
            });
        } else if (
            apiData &&
            apiData.oilLifeData &&
            apiData.scheduleMaintenanceData === null
        ) {
            return replacePlaceholderByValue(content.oilLifeSubTitle, {
                oilLife: apiData.oilLifeData.featureData.iolm,
            });
        } else if (
            apiData &&
            apiData.scheduleMaintenanceData &&
            apiData.oilLifeData === null
        ) {
            return replacePlaceholderByValue(
                content.scheduledMaintenanceSubTitle,
                {
                    currentMileage: currentMileage,
                    mileageInterval:
                        uomDistance === 1
                            ? apiData.scheduleMaintenanceData.featureData
                                  .nextIntervalMiles
                            : apiData.scheduleMaintenanceData.featureData
                                  .nextIntervalKMs,
                    distanceUnit: distanceUnit,
                }
            );
        } else return '';
    };
    return {
        type: FM_ACTION_ITEMS_TYPE.SERVICE_REMINDER,
        title: getCardTitle(),
        subtitle: getCardSubTitle(),
        ctaTitle: content.scheduleServiceCtaTitle,
        ctaPath: content.scheduleServiceCtaHref,
        ctaTargetBlank: content.scheduleServiceCtaTargetBlank,
    };
};
